import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties, { IBaseNFTAttributes } from '../../models/INFTProperties'
import { INeonMonstersCard } from '../Cards/NeonMonstersCard'
import BaseDetail from './BaseDetail'

export default function NeonMonstersDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const [detailTokenItem, setDetailTokenItem] = useState<INeonMonstersCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri.replace('ipfs://', 'https://ipfs.io/ipfs/')).then((tokenResult: any) =>
        setDetailTokenItem(tokenResult)
      )
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value,
        show: true,
        isUrl: false
      }))
    }

    return result
  }

  function getDescription() {
    return (
      <div>
        What is Neon Monsters?
        <p>
          Neon Monsters are a collection of algorithmically generated NFTs on the Avalanche. The 1st generation consists
          of 10,000 randomly assembled monsters. You can earn passive income with your monsters. Neon Monsters have a
          reflective system where holders and minters get rewards when their monsters are minted or traded.
        </p>
      </div>
    )
  }

  return (
    <BaseDetail
      {...props}
      description={getDescription()}
      tokenItemName={detailTokenItem ? detailTokenItem.name : ''}
      properites={getNFTProperties()}
    >
      {detailTokenItem ? (
        <img src={detailTokenItem.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={detailTokenItem.name} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
